import { createContext } from "react";

interface ScrollContextProps {
  scrollableContainerRef: React.RefObject<HTMLDivElement | null>;
}

export const ScrollContext = createContext<ScrollContextProps>({
  scrollableContainerRef: {} as React.RefObject<HTMLDivElement | null>,
});
